import { render } from "./ResultTab.vue?vue&type=template&id=a6f76596"
import script from "./ResultTab.vue?vue&type=script&lang=js"
export * from "./ResultTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__